import { motion } from 'framer-motion';

const features = [
  { icon: '📚', title: '600+ modeller', text: 'Allt från små familjeborgar till tävlingsformat för event.' },
  { icon: '🎨', title: 'Egen design & logo', text: 'Vi formger din borg med dina färger och varumärke.' },
  { icon: '🚚', title: 'Direktförsäljning', text: 'Lagervaror finns för snabb leverans i hela Norden.' },
  { icon: '⏱️', title: 'Leveranstid ca 12 v', text: 'För skräddarsydda beställningar — vi guidar hela vägen.' },
];

export default function Sales() {
  return (
    <section id="forsaljning" className="relative py-16 sm:py-20 bg-grape text-cream overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10 opacity-40">
        <div className="absolute -top-40 -left-20 size-[30rem] rounded-full bg-sky blur-3xl" />
        <div className="absolute -bottom-32 -right-20 size-[28rem] rounded-full bg-bubble blur-3xl" />
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="inline-flex items-center gap-2 rounded-full bg-cream/15 border border-cream/20 px-3 py-1 text-xs font-semibold uppercase tracking-wider"
            >
              <span className="size-1.5 rounded-full bg-sun" />
              Köp din egen hoppborg
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.05 }}
              className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.02] text-balance"
            >
              Designa borgen som <span className="text-sun">bär ditt varumärke</span>.
            </motion.h2>
            <p className="mt-5 text-cream/80 text-lg max-w-lg text-pretty">
              Investera i en egen aktivitet — perfekt för uthyrare, festivaler, kommuner och företag som vill skapa
              upplevelser om och om igen.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#kontakt"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-sun text-ink px-7 py-4 text-base font-semibold shadow-bouncy hover:-translate-y-0.5 transition-transform"
              >
                Begär offert →
              </a>
              <a
                href="#aktiviteter"
                className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-cream/30 px-7 py-4 text-base font-semibold hover:bg-cream/10 transition-colors"
              >
                Se kollektion
              </a>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="grid sm:grid-cols-2 gap-4">
              {features.map((f, i) => (
                <motion.div
                  key={f.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  whileHover={{ y: -6 }}
                  className={`rounded-3xl bg-cream/10 backdrop-blur border border-cream/15 p-6 ${
                    i % 2 === 0 ? 'sm:translate-y-6' : ''
                  }`}
                >
                  <div className="size-12 grid place-items-center rounded-2xl bg-cream text-ink text-xl">{f.icon}</div>
                  <h3 className="mt-4 font-display text-xl font-semibold">{f.title}</h3>
                  <p className="mt-2 text-sm text-cream/75 leading-relaxed">{f.text}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
